
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-157ef01c\",\"scoped\":true,\"hasInlineConfig\":false}!scss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./trade.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./trade.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-157ef01c\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./trade.vue"),
  /* scopeId */
  "data-v-157ef01c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/views/report/trade.vue
// module id = 867
// module chunks = 0